import { Skeleton } from '../../../../components/Skeleton';
import styles from './AchievementsTabSkeleton.module.scss';

export interface AchievementsTabSkeletonProps {
  className?: string;
}

export function AchievementsTabSkeleton({ className }: AchievementsTabSkeletonProps) {
  const classes = [styles.achievementsTabSkeleton, className].filter(Boolean).join(' ');

  return (
    <div className={classes} aria-hidden="true">
      {/* Stats header area — 3 stat blocks in a row */}
      <div className={styles.statsHeader}>
        <Skeleton width="100%" height="80px" borderRadius="8px" />
        <Skeleton width="100%" height="80px" borderRadius="8px" />
        <Skeleton width="100%" height="80px" borderRadius="8px" />
      </div>

      {/* Accordion item placeholders — game name + progress bar */}
      {Array.from({ length: 5 }, (_, i) => (
        <div key={i} className={styles.accordionItem}>
          <div className={styles.accordionHeader}>
            <Skeleton width="40px" height="40px" borderRadius="4px" />
            <Skeleton width="60%" height="1rem" />
            <Skeleton width="80px" height="0.875rem" />
          </div>
          <Skeleton width="100%" height="8px" borderRadius="4px" />
        </div>
      ))}
    </div>
  );
}

export default AchievementsTabSkeleton;
